<!--
  Landingpage „Verkaufsautomat mieten“. Fokus: MIETE (Käufer-Intent), mit
  Miete-vs-Kauf-Vergleich als Herzstück (Abgrenzung zum Kauf-Hub /verkaufsautomat).
  Keywords: verkaufsautomat(en) mieten / automat mieten / leasing.
  Blog-Zubringer: ein-eigener-verkaufsautomat-kaufen-oder-mieten.
-->
<section class="lp-hero">
  <div class="content content--wide lp-hero__grid">
    <div class="lp-hero__text reveal">
      <div class="lp-hero__orb" aria-hidden="true">🔑</div>
      <span class="lp-eyebrow" i18n="@@miete.hero.eyebrow">Flexibel starten · ab 300 €/Monat</span>
      <h1 class="title display" i18n="@@miete.hero.h1">Verkaufsautomat mieten</h1>
      <div class="line"></div>
      <p class="lp-lead" i18n="@@miete.hero.lead">
        Starte ohne hohe Anfangsinvestition: Miete deine <span class="tm">marktbox</span> ab
        300 € im Monat – bargeldlos, app-gesteuert und sofort einsatzbereit. Planbare Kosten,
        volle Flexibilität und die Möglichkeit, klein zu starten und später zu erweitern.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@miete.hero.ctaShop">Modelle &amp; Mietpreise im Shop</a>
        <a class="lp-cta__ghost" href="#vergleich" (click)="scrollTo($event, 'vergleich')" i18n="@@miete.hero.ctaAnchor">Mieten oder kaufen? ↓</a>
      </div>
    </div>
    <figure class="lp-hero__media reveal">
      <img src="assets/headers/marktbox-00-1440.webp"
        alt="marktbox Verkaufsautomat zur Miete – flexibel ab 300 € pro Monat" i18n-alt="@@miete.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="lp-hero__badge" i18n="@@miete.hero.badge">📆 monatlich planbar</span>
    </figure>
  </div>
</section>

<!-- ===== Warum mieten? ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@miete.why.h2">Warum einen Verkaufsautomaten mieten?</h2>
    <div class="lp-grid">
      <div class="lp-card reveal">
        <span class="lp-card__ico">💶</span>
        <h3 i18n="@@miete.why.c1.h3">Keine hohe Anfangsinvestition</h3>
        <p i18n="@@miete.why.c1.p">Statt einmalig mehrere Tausend Euro zu investieren, startest du mit einer planbaren Monatsrate ab 300 €.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">📆</span>
        <h3 i18n="@@miete.why.c2.h3">Planbare Kosten</h3>
        <p i18n="@@miete.why.c2.p">Feste monatliche Rate – ideal für die Kalkulation und den Cashflow, gerade in der Startphase.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🧪</span>
        <h3 i18n="@@miete.why.c3.h3">Erst testen, dann skalieren</h3>
        <p i18n="@@miete.why.c3.p">Probiere einen Standort oder ein Sortiment ohne großes Risiko aus und erweitere später Automat für Automat.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🌱</span>
        <h3 i18n="@@miete.why.c4.h3">Ideal für den Einstieg &amp; Saison</h3>
        <p i18n="@@miete.why.c4.p">Perfekt für Direktvermarkter am Anfang oder saisonale Verkäufe wie Erdbeeren und Spargel.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Mieten oder kaufen? (Vergleich = Herzstück) ===== -->
<section id="vergleich" class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@miete.compare.h2">Mieten oder kaufen?</h2>
    <p class="lp-intro reveal" i18n="@@miete.compare.intro">
      Beides ist möglich – es kommt auf deine Situation an. Mieten senkt die Einstiegshürde und hält
      die Kosten planbar; Kaufen lohnt sich, wenn der Automat dauerhaft an einem Standort läuft.
    </p>
    <div class="lp-price-grid">
      <div class="lp-price lp-price--featured reveal">
        <span class="lp-price__label" i18n="@@miete.compare.rentLabel">Mieten</span>
        <span class="lp-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <ul class="lp-live__list">
          <li i18n="@@miete.compare.rent1">Niedrige Einstiegshürde, kein gebundenes Kapital</li>
          <li i18n="@@miete.compare.rent2">Planbare monatliche Kosten</li>
          <li i18n="@@miete.compare.rent3">Flexibel zum Starten, Testen &amp; für Saison</li>
        </ul>
      </div>
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@miete.compare.buyLabel">Kaufen</span>
        <span class="lp-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <ul class="lp-live__list">
          <li i18n="@@miete.compare.buy1">Einmalige Investition, dauerhaft dein Automat</li>
          <li i18n="@@miete.compare.buy2">Günstiger über die lange Laufzeit</li>
          <li i18n="@@miete.compare.buy3">Ideal für feste, dauerhafte Standorte</li>
        </ul>
      </div>
    </div>
    <div class="lp-cta lp-cta--center reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@miete.compare.cta">Modelle &amp; Mietpreise im Shop</a>
      <a class="lp-cta__ghost" [routerLink]="['/', 'verkaufsautomat']" i18n="@@miete.compare.buyLink">Lieber kaufen? Zur Übersicht →</a>
    </div>
    <p class="lp-fineprint reveal" i18n="@@miete.compare.fine">
      Unentschlossen? <a [routerLink]="['/', links.blog, blogSlug]">Im Ratgeber: Verkaufsautomat kaufen oder mieten</a>
    </p>
  </div>
</section>

<!-- ===== Live-Link ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide lp-live__grid">
    <div class="lp-live__text reveal">
      <span class="lp-eyebrow" i18n="@@miete.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="lp-h2" i18n="@@miete.live.h2">Auch zur Miete: der Live-Link inklusive</h2>
      <p class="lp-lead" i18n="@@miete.live.lead">
        Jede marktbox – ob gekauft oder gemietet – hat ihren eigenen Live-Link. Deine Kundschaft
        sieht in Echtzeit, was gerade verfügbar ist, noch bevor sie losfährt.
      </p>
      <ul class="lp-live__list">
        <li i18n="@@miete.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@miete.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@miete.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@miete.live.cta">Jetzt mieten &amp; loslegen</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link: Echtzeit-Verfügbarkeit einer Box" i18n-title="@@miete.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@miete.live.cap">Live-Beispiel: Obsthof Zink</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@miete.faq.h2">Häufige Fragen zum Mieten</h2>
    <div class="lp-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="lp-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="lp-section lp-final reveal">
  <div class="content content--wide">
    <h2 class="lp-h2" i18n="@@miete.final.h2">Bereit, deine marktbox zu mieten?</h2>
    <p class="lp-lead" i18n="@@miete.final.lead">Klein starten, planbar bleiben, jederzeit erweitern – wähle dein Modell und leg los.</p>
    <div class="lp-cta lp-cta--center">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@miete.final.cta">Jetzt Modelle &amp; Mietpreise ansehen</a>
    </div>
  </div>
</section>
